const homeMainBanner = {
  initializeSlider: () => {
    $(".themeHomeBanner__slider").slick({
      infinite: true,
      slidesToShow: 1,
      arrows: true,
      dots: true
    });
  },
  init: () => {
    homeMainBanner.initializeSlider();
  },
};

export default homeMainBanner;
